import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1da71de2"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "frisbuy-text-modal__card",
  role: "dialog",
  "aria-modal": "true"
}
const _hoisted_2 = { class: "frisbuy-text-modal__header" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M17.6077 6.29437C17.2138 5.90724 16.5807 5.91272 16.1936 6.3066L11.9878 10.5857L7.70878 6.38003C7.31489 5.9929 6.68175 5.99838 6.29462 6.39227C5.90748 6.78615 5.91296 7.4193 6.30685 7.80643L10.5859 12.0121L6.38006 16.2914C5.99293 16.6852 5.9984 17.3184 6.39229 17.7055C6.78618 18.0926 7.41932 18.0872 7.80645 17.6933L12.0123 13.414L16.2916 17.6199C16.6855 18.0071 17.3186 18.0016 17.7058 17.6077C18.0929 17.2138 18.0874 16.5807 17.6935 16.1935L13.4142 11.9876L17.6199 7.70853C18.0071 7.31465 18.0016 6.6815 17.6077 6.29437Z",
    fill: "#999999"
  })
], -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { class: "frisbuy-text-modal__scroll" }
const _hoisted_6 = { class: "frisbuy-text-modal__head" }
const _hoisted_7 = { class: "frisbuy-text-modal__author" }
const _hoisted_8 = { class: "frisbuy-text-modal__meta" }
const _hoisted_9 = { class: "frisbuy-text-modal__name" }
const _hoisted_10 = { class: "frisbuy-text-modal__date" }
const _hoisted_11 = {
  key: 0,
  class: "frisbuy-text-modal__rating"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "frisbuy-text-modal__rating-icon",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M18.5475 9.00373L14.3506 8.38782L12.4744 4.54711C12.4232 4.44196 12.3389 4.35683 12.2348 4.30509C11.9736 4.17489 11.6562 4.28339 11.5256 4.54711L9.64949 8.38782L5.45256 9.00373C5.33685 9.02043 5.23106 9.07551 5.15007 9.15897C5.05215 9.26059 4.99819 9.39732 5.00005 9.5391C5.00191 9.68088 5.05943 9.81611 5.15998 9.91509L8.19652 12.9045L7.47912 17.1258C7.4623 17.224 7.47306 17.325 7.51018 17.4173C7.54731 17.5097 7.60931 17.5896 7.68916 17.6482C7.76901 17.7068 7.86352 17.7416 7.96196 17.7486C8.0604 17.7557 8.15883 17.7348 8.24611 17.6883L12 15.6953L15.754 17.6883C15.8564 17.7434 15.9755 17.7617 16.0895 17.7417C16.3771 17.6916 16.5705 17.4162 16.5209 17.1258L15.8036 12.9045L18.8401 9.91509C18.9227 9.8333 18.9773 9.72647 18.9938 9.60963C19.0384 9.31753 18.8368 9.04713 18.5475 9.00373Z",
      fill: "#212121"
    })
  ])
], -1))
const _hoisted_13 = { class: "frisbuy-text-modal__body" }
const _hoisted_14 = {
  key: 0,
  class: "frisbuy-text-modal__block"
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "frisbuy-text-modal__label" }, "Преимущества:", -1))
const _hoisted_16 = {
  key: 1,
  class: "frisbuy-text-modal__block"
}
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "frisbuy-text-modal__label" }, "Недостатки:", -1))
const _hoisted_18 = {
  key: 2,
  class: "frisbuy-text-modal__comment"
}
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "frisbuy-text-modal__footer",
  "aria-hidden": "true"
}, null, -1))

import { computed, onBeforeUnmount, onMounted } from "vue";
import { IMarketplaceReviewsPost } from "../../interfaces";


export default /*#__PURE__*/_defineComponent({
  __name: 'PopupReviewText',
  props: {
    post: {},
    selectedPostIndex: {},
    reviewDate: {}
  },
  emits: ["close"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const avatarColors = [
  "rgba(188, 200, 210, 1)",
  "rgba(114, 207, 154, 1)",
  "rgba(158, 204, 246, 1)",
  "rgba(127, 131, 234, 1)",
  "rgba(121, 85, 72, 1)",
];

const authorName = computed(() => {
  return (
    props.post.instagramPost.authorUser.fio ||
    `@${props.post.instagramPost.authorUser.username}`
  );
});

const authorInitial = computed(() => {
  const name = authorName.value.trim();
  return (name[0] || "A").toUpperCase();
});

const avatarStyle = computed(() => {
  const index =
    (Math.max(1, props.selectedPostIndex + 1) - 1) % avatarColors.length;
  return { background: avatarColors[index] };
});

onMounted(() => {
  document.documentElement.style.overflow = "hidden";
});

onBeforeUnmount(() => {
  document.documentElement.style.overflow = "";
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "frisbuy-text-modal",
    onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (emit('close')), ["self"]))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("button", {
          class: "frisbuy-text-modal__close",
          type: "button",
          "aria-label": "Close",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('close')))
        }, _hoisted_4)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", {
              class: "frisbuy-text-modal__avatar",
              style: _normalizeStyle(avatarStyle.value)
            }, _toDisplayString(authorInitial.value), 5),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, _toDisplayString(authorName.value), 1),
              _createElementVNode("div", _hoisted_10, _toDisplayString(props.reviewDate), 1)
            ])
          ]),
          (props.post.frisbuyPost.rating)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                _hoisted_12,
                _createElementVNode("span", null, _toDisplayString(props.post.frisbuyPost.rating), 1)
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_13, [
          (props.post.frisbuyPost.positiveComment)
            ? (_openBlock(), _createElementBlock("p", _hoisted_14, [
                _hoisted_15,
                _createTextVNode(" " + _toDisplayString(props.post.frisbuyPost.positiveComment), 1)
              ]))
            : _createCommentVNode("", true),
          (props.post.frisbuyPost.negativeComment)
            ? (_openBlock(), _createElementBlock("p", _hoisted_16, [
                _hoisted_17,
                _createTextVNode(" " + _toDisplayString(props.post.frisbuyPost.negativeComment), 1)
              ]))
            : _createCommentVNode("", true),
          (props.post.frisbuyPost.text)
            ? (_openBlock(), _createElementBlock("p", _hoisted_18, _toDisplayString(props.post.frisbuyPost.text), 1))
            : _createCommentVNode("", true)
        ])
      ]),
      _hoisted_19
    ])
  ]))
}
}

})